/**
 * Build-time environment switch for the AI voice interviewer.
 *
 * Mock mode lets the whole interview flow run without spending Gemini tokens or
 * needing a live WebSocket. The gate is the build mode, not `import.meta.env.DEV`
 * (Vite's `vite build` always sets NODE_ENV=production, so DEV is false in every
 * build). `import.meta.env.MODE` is the literal build mode: "development" for the
 * dev deploy and "production" for prod, so a production bundle can never ship the
 * scripted mock.
 */
export const INTERVIEW_MOCK_MODE =
  import.meta.env.VITE_INTERVIEW_MOCK_MODE === 'true' && import.meta.env.MODE === 'development';

/**
 * The SDK's ephemeral-token WebSocket path is currently implemented on
 * `v1alpha` (BidiGenerateContentConstrained). Overridable for live regressions.
 */
export const GENAI_API_VERSION: string =
  import.meta.env.VITE_GENAI_API_VERSION || 'v1alpha';